import { render, staticRenderFns } from "./idcard.vue?vue&type=template&id=c4066d30&scoped=true"
import script from "./idcard.vue?vue&type=script&lang=js"
export * from "./idcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4066d30",
  null
  
)

/* custom blocks */
import block0 from "./idcard.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports